import React from 'react';
import ValidationForm from  '../components/ValidationForm.js'
import withLoginLayout from "./../hocs/withLoginLayout";

function Login(props) {
    return (
      <ValidationForm />
    );
}
export default withLoginLayout(Login);